import {
	RUN_NAMES_FILTER_KEY,
	TRIP_NUMBERS_FILTER_KEY,
} from 'pages/RideListPage/components/RideFilters/filterConstants';

export const getIdValue = (type, value) => {
	if (type === RUN_NAMES_FILTER_KEY) {
		return value;
	}

	if (Object.hasOwn(value, 'key')) {
		return value.key;
	}

	return value;
};

export const getValueToPush = (value, targetKey) => {
	if (targetKey === TRIP_NUMBERS_FILTER_KEY) {
		return Number(value);
	}

	// Guard Clause 2: Handle the specific filter key
	if (targetKey === RUN_NAMES_FILTER_KEY) {
		return value;
	}

	return value?.key;
};
